import React from "react";

const NetworkIcon = () => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19.9797 25.9579L14.0093 20.0016L19.9797 14.0453L25.9501 20.0016L19.9797 25.9579Z" fill="#FEFEFE" />
        <path d="M29.6159 10.3904L20.0206 6.49951L10.3853 10.4304L19.9806 14.0415L29.6159 10.3904Z" fill="#E65C1B" />
        <path d="M25.9504 19.998L29.6153 10.3906L19.98 14.0417L25.9504 19.998Z" fill="#362D7E" />
        <path d="M19.98 25.9545L29.6153 29.5656L25.9504 19.9982L19.98 25.9545Z" fill="#ECAE0E" />
        <path d="M19.9806 14.038L10.3853 10.4269L14.0102 19.9943L19.9806 14.038Z" fill="#ECAE0E" />
        <path d="M10.3847 10.4271C10.3314 10.3738 6.43994 19.9945 6.43994 19.9945L10.3847 29.562L14.0096 19.9945L10.3847 10.4271Z" fill="#E31D25" />
        <path d="M14.0102 19.9982L10.3853 29.5656L19.9806 25.9545L14.0102 19.9982Z" fill="#ECAE0E" />
        <path d="M10.3853 29.5696L19.9806 33.5005L29.6159 29.5696L19.9806 25.9585L10.3853 29.5696Z" fill="#E31D25" />
        <path d="M29.6151 10.3906L25.9502 19.998L29.6151 29.5655L33.5598 19.998L29.6151 10.3906Z" fill="#E65C1B" />
    </svg>
);

export default NetworkIcon;